import {
  UPDATE_ADMIN_SHARED_TENANT_STATUS_REQUEST,
  UPDATE_ADMIN_SHARED_TENANT_STATUS_SUCCESS,
  UPDATE_ADMIN_SHARED_TENANT_STATUS_FAILURE,
  UPDATE_ADMIN_BOOKING_LABELS_REQUEST,
  UPDATE_ADMIN_BOOKING_LABELS_SUCCESS,
  UPDATE_ADMIN_BOOKING_LABELS_FAILURE,
  UPDATE_ADMIN_BOOKING_TENANT_FEATURES_REQUEST,
  UPDATE_ADMIN_BOOKING_TENANT_FEATURES_SUCCESS,
  UPDATE_ADMIN_BOOKING_TENANT_FEATURES_FAILURE,
  FETCH_ADMIN_BOOKING_VERSION_FEATURES_REQUEST,
  FETCH_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS,
  FETCH_ADMIN_BOOKING_VERSION_FEATURES_FAILURE,
  UPDATE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST,
  UPDATE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS,
  UPDATE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE,
  DELETE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST,
  DELETE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS,
  DELETE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE,
  UPDATE_ADMIN_FAULT_STATUS_REQUEST,
  UPDATE_ADMIN_FAULT_STATUS_SUCCESS,
  UPDATE_ADMIN_FAULT_STATUS_FAILURE,
  CLEAR_ADMIN_SHARED_TENANT_MUTATION_ERRORS,
  UPDATE_ADMIN_SHARED_TENANT_EDIT_REQUEST,
  UPDATE_ADMIN_SHARED_TENANT_EDIT_SUCCESS,
  UPDATE_ADMIN_SHARED_TENANT_EDIT_FAILURE,
  ONBOARD_ADMIN_SHARED_TENANT_REQUEST,
  ONBOARD_ADMIN_SHARED_TENANT_SUCCESS,
  ONBOARD_ADMIN_SHARED_TENANT_FAILURE,
  RESET_ADMIN_SHARED_TENANT_PASSWORDS_REQUEST,
  RESET_ADMIN_SHARED_TENANT_PASSWORDS_SUCCESS,
  RESET_ADMIN_SHARED_TENANT_PASSWORDS_FAILURE,
  RUN_ADMIN_SHARED_TENANT_CLEANUP_REQUEST,
  RUN_ADMIN_SHARED_TENANT_CLEANUP_SUCCESS,
  RUN_ADMIN_SHARED_TENANT_CLEANUP_FAILURE,
  DELETE_ADMIN_SHARED_TENANT_REQUEST,
  DELETE_ADMIN_SHARED_TENANT_SUCCESS,
  DELETE_ADMIN_SHARED_TENANT_FAILURE,
  RELEASE_ADMIN_SHARED_TENANT_REQUEST,
  RELEASE_ADMIN_SHARED_TENANT_SUCCESS,
  RELEASE_ADMIN_SHARED_TENANT_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  statusUpdate: { loading: false, error: null },
  labelsUpdate: { loading: false, error: null },
  tenantFeaturesUpdate: { loading: false, error: null },
  faultUpdate: { loading: false, error: null },
  editUpdate: { loading: false, error: null },
  onboardUpdate: { loading: false, error: null },
  passwordReset: { loading: false, error: null, lastResult: null },
  cleanup: { loading: false, error: null, lastResult: null },
  deleteTenant: { loading: false, error: null },
  releaseTenant: { loading: false, error: null },
  versionFeaturesAdmin: {
    list: [],
    loading: false,
    error: null,
    updating: false,
    deleting: false,
  },
};

const adminSharedTenantMutationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ADMIN_SHARED_TENANT_STATUS_REQUEST:
      return { ...state, statusUpdate: { loading: true, error: null } };
    case UPDATE_ADMIN_SHARED_TENANT_STATUS_SUCCESS:
      return { ...state, statusUpdate: { loading: false, error: null } };
    case UPDATE_ADMIN_SHARED_TENANT_STATUS_FAILURE:
      return { ...state, statusUpdate: { loading: false, error: action.payload } };

    case UPDATE_ADMIN_BOOKING_LABELS_REQUEST:
      return { ...state, labelsUpdate: { loading: true, error: null } };
    case UPDATE_ADMIN_BOOKING_LABELS_SUCCESS:
      return { ...state, labelsUpdate: { loading: false, error: null } };
    case UPDATE_ADMIN_BOOKING_LABELS_FAILURE:
      return { ...state, labelsUpdate: { loading: false, error: action.payload } };

    case UPDATE_ADMIN_BOOKING_TENANT_FEATURES_REQUEST:
      return { ...state, tenantFeaturesUpdate: { loading: true, error: null } };
    case UPDATE_ADMIN_BOOKING_TENANT_FEATURES_SUCCESS:
      return { ...state, tenantFeaturesUpdate: { loading: false, error: null } };
    case UPDATE_ADMIN_BOOKING_TENANT_FEATURES_FAILURE:
      return { ...state, tenantFeaturesUpdate: { loading: false, error: action.payload } };

    case FETCH_ADMIN_BOOKING_VERSION_FEATURES_REQUEST:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          loading: true,
          error: null,
        },
      };
    case FETCH_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          list: action.payload || [],
          loading: false,
          error: null,
        },
      };
    case FETCH_ADMIN_BOOKING_VERSION_FEATURES_FAILURE:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          loading: false,
          error: action.payload,
        },
      };

    case UPDATE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          updating: true,
          error: null,
        },
      };
    case UPDATE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          updating: false,
          error: null,
        },
      };
    case UPDATE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          updating: false,
          error: action.payload,
        },
      };

    case DELETE_ADMIN_BOOKING_VERSION_FEATURES_REQUEST:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          deleting: true,
          error: null,
        },
      };
    case DELETE_ADMIN_BOOKING_VERSION_FEATURES_SUCCESS:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          deleting: false,
          error: null,
        },
      };
    case DELETE_ADMIN_BOOKING_VERSION_FEATURES_FAILURE:
      return {
        ...state,
        versionFeaturesAdmin: {
          ...state.versionFeaturesAdmin,
          deleting: false,
          error: action.payload,
        },
      };

    case UPDATE_ADMIN_FAULT_STATUS_REQUEST:
      return { ...state, faultUpdate: { loading: true, error: null } };
    case UPDATE_ADMIN_FAULT_STATUS_SUCCESS:
      return { ...state, faultUpdate: { loading: false, error: null } };
    case UPDATE_ADMIN_FAULT_STATUS_FAILURE:
      return { ...state, faultUpdate: { loading: false, error: action.payload } };

    case UPDATE_ADMIN_SHARED_TENANT_EDIT_REQUEST:
      return { ...state, editUpdate: { loading: true, error: null } };
    case UPDATE_ADMIN_SHARED_TENANT_EDIT_SUCCESS:
      return { ...state, editUpdate: { loading: false, error: null } };
    case UPDATE_ADMIN_SHARED_TENANT_EDIT_FAILURE:
      return { ...state, editUpdate: { loading: false, error: action.payload } };

    case ONBOARD_ADMIN_SHARED_TENANT_REQUEST:
      return { ...state, onboardUpdate: { loading: true, error: null } };
    case ONBOARD_ADMIN_SHARED_TENANT_SUCCESS:
      return { ...state, onboardUpdate: { loading: false, error: null } };
    case ONBOARD_ADMIN_SHARED_TENANT_FAILURE:
      return { ...state, onboardUpdate: { loading: false, error: action.payload } };

    case RESET_ADMIN_SHARED_TENANT_PASSWORDS_REQUEST:
      return { ...state, passwordReset: { loading: true, error: null, lastResult: null } };
    case RESET_ADMIN_SHARED_TENANT_PASSWORDS_SUCCESS:
      return { ...state, passwordReset: { loading: false, error: null, lastResult: action.payload } };
    case RESET_ADMIN_SHARED_TENANT_PASSWORDS_FAILURE:
      return { ...state, passwordReset: { loading: false, error: action.payload, lastResult: null } };

    case RUN_ADMIN_SHARED_TENANT_CLEANUP_REQUEST:
      return { ...state, cleanup: { loading: true, error: null, lastResult: null } };
    case RUN_ADMIN_SHARED_TENANT_CLEANUP_SUCCESS:
      return { ...state, cleanup: { loading: false, error: null, lastResult: action.payload } };
    case RUN_ADMIN_SHARED_TENANT_CLEANUP_FAILURE:
      return { ...state, cleanup: { loading: false, error: action.payload, lastResult: null } };

    case DELETE_ADMIN_SHARED_TENANT_REQUEST:
      return { ...state, deleteTenant: { loading: true, error: null } };
    case DELETE_ADMIN_SHARED_TENANT_SUCCESS:
      return { ...state, deleteTenant: { loading: false, error: null } };
    case DELETE_ADMIN_SHARED_TENANT_FAILURE:
      return { ...state, deleteTenant: { loading: false, error: action.payload } };

    case RELEASE_ADMIN_SHARED_TENANT_REQUEST:
      return { ...state, releaseTenant: { loading: true, error: null } };
    case RELEASE_ADMIN_SHARED_TENANT_SUCCESS:
      return { ...state, releaseTenant: { loading: false, error: null } };
    case RELEASE_ADMIN_SHARED_TENANT_FAILURE:
      return { ...state, releaseTenant: { loading: false, error: action.payload } };

    case CLEAR_ADMIN_SHARED_TENANT_MUTATION_ERRORS:
      return {
        ...state,
        statusUpdate: { ...state.statusUpdate, error: null },
        labelsUpdate: { ...state.labelsUpdate, error: null },
        tenantFeaturesUpdate: { ...state.tenantFeaturesUpdate, error: null },
        faultUpdate: { ...state.faultUpdate, error: null },
        editUpdate: { ...state.editUpdate, error: null },
        onboardUpdate: { ...state.onboardUpdate, error: null },
        passwordReset: { ...state.passwordReset, error: null },
        cleanup: { ...state.cleanup, error: null },
        deleteTenant: { ...state.deleteTenant, error: null },
        releaseTenant: { ...state.releaseTenant, error: null },
        versionFeaturesAdmin: { ...state.versionFeaturesAdmin, error: null },
      };

    default:
      return state;
  }
};

export default adminSharedTenantMutationsReducer;
